// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/MUI";

// Data
import axios from "axios";
import { withAuthContext } from "context/Auth";
import { useEffect, useState, useMemo } from "react";
import MDBadge from "components/MDBadge";
import ComplainCategoryIcon from "assets/images/bg-profile.jpeg";
import { useNavigate, useParams } from "react-router-dom";
import ImageCloud from "../../link";

function Tables({ AdminRole }) {
	const { ComplainId } = useParams();
	const navigate = useNavigate();
	const [data, setData] = useState([]);
	const [error, setError] = useState("");
	const [isLoading, setIsLoading] = useState(false);
	const [pagination, setPagination] = useState({ total: 0, page: 1, limit: 10, totalPages: 0 });
	const [currentPage, setCurrentPage] = useState(1);
	const [itemsPerPage, setItemsPerPage] = useState(10);

	// ✅ Memoized columns so they don’t recreate every render
	const columns = useMemo(
		() => [
			{
				flex: 1,
				headerName: "",
				field: "Icon",
				renderCell: (params) => (
					<img
						src={
							params?.row?.Icon?.filename
								? `${ImageCloud}/${params?.row?.Icon?.filename}`
								: ComplainCategoryIcon
						}
						style={{
							width: "50px",
							height: "50px",
							borderRadius: "50px",
							border: "1px solid #000",
						}}
					/>
				),
			},
			{ flex: 2, headerName: "title", field: "title" },
			{
				flex: 2,
				headerName: "Complain",
				field: "Complain",
				valueGetter: (params) => `${params.row?.Complain?.length || "0"}`,
			},
			{
				flex: 1,
				headerName: "Action",
				field: "action",
				renderCell: (params) => (
					<MDBox>
						{AdminRole == "superadmin" && (
							<MDBadge
								badgeContent={"Edit"}
								color={"warning"}
								variant="gradient"
								size="sm"
								onClick={() => {
									navigate(`/ComplainCategoryAction/${params?.row?._id}`);
								}}
							/>
						)}
						{ComplainId && (
							<MDBadge
								badgeContent={"Select Complain"}
								color={"warning"}
								variant="gradient"
								size="sm"
								onClick={() => {
									navigate(`/ComplainPropertySelect/${params?.row?._id}`);
								}}
							/>
						)}
					</MDBox>
				),
			},
		],
		[AdminRole, ComplainId, navigate]
	);

	const GetComplainCategorys = () => {
		setIsLoading(true);
		axios
			.get(`${process.env.REACT_APP_PUBLIC_PATH}/GetAllComplainCategory?page=${currentPage}&limit=${itemsPerPage}`)
			.then((res) => {
				if (res?.data?.status == 200) {
					setData(res?.data?.data);
					if (res?.data?.pagination) {
						setPagination(res?.data?.pagination);
					}
				} else {
					setError(res?.data?.message);
				}
				})
				.catch((err) => {
					setError(err?.message);
				})
				.finally(() => {
					setIsLoading(false);
				});
	};

	useEffect(() => {
		GetComplainCategorys();
	}, [currentPage, itemsPerPage]);

	const handlePageChange = (newPage, newPageSize) => {
		if (newPageSize !== itemsPerPage) {
			setItemsPerPage(newPageSize);
			setCurrentPage(1);
		} else {
			setCurrentPage(newPage);
		}
	};
	
	// ✅ Memoized table content
	const ComplainCategoryTable = useMemo(
		() => (
			<Card>
				<MDBox
					mx={2}
					mt={-3}
					py={3}
					px={2}
					variant="gradient"
					bgColor="info"
					borderRadius="lg"
					coloredShadow="info"
				>
					<Grid container style={{ width: "100%" }}>
						<Grid item xs={6}>
							<MDTypography variant="h6" color="white">
								Complain Category
							</MDTypography>
						</Grid>
						{AdminRole == "superadmin" && (
							<Grid
								item
								xs={6}
								style={{
									display: "flex",
									alignItems: "flex-end",
									alignContent: "flex-end",
									justifyContent: "flex-end",
								}}
							>
								<MDBadge
									badgeContent="New"
									color="dark"
									variant="gradient"
									size="sm"
									onClick={() => navigate(`/ComplainCategoryAction/New`)}
								/>
							</Grid>
						)}
					</Grid>
				</MDBox>

			<MDBox pt={3}>
				{isLoading ? (
					<MDBox lineHeight={1} textAlign="center" py={3}>
						<MDTypography display="block" variant="caption" color="text" fontWeight="medium" fontSize="16px">
							Loading...
						</MDTypography>
					</MDBox>
			) : data.length > 0 ? (
				<DataTable 
					rows={data} 
					columns={columns} 
					paginationMode="server"
					serverPagination={{
						total: pagination?.total || 0,
						page: currentPage,
						limit: itemsPerPage,
						onPageChange: handlePageChange
					}}
				/>
				) : (
					<MDBox lineHeight={1} textAlign="center">
						<MDTypography
							display="block"
							variant="caption"
							color="text"
							fontWeight="medium"
							fontSize="20px"
						>
							{error ? error : " No Data Found"}
						</MDTypography>
					</MDBox>
				)}
			</MDBox>
		</Card>
	),
	[data, error, columns, AdminRole, navigate, isLoading, pagination, currentPage, itemsPerPage, handlePageChange]
);	return (
		<DashboardLayout>
			<DashboardNavbar />
			<MDBox pt={6} pb={3}>
				<Grid container spacing={6}>
					<Grid item xs={12}>
						{ComplainCategoryTable}
					</Grid>
				</Grid>
			</MDBox>
		</DashboardLayout>
	);
}

export default withAuthContext(Tables);
